import React from "react";
import CollapsableTableCell from "./collapsibleTableCell";

interface ICollapsibleEmptyCheckBoxCellProps {
    expanded: boolean;
}

const CollapsibleEmptyCheckBoxCell: React.FC<ICollapsibleEmptyCheckBoxCellProps> = ({
    expanded
}) => {
    return <CollapsableTableCell 
        expanded={expanded}
        tableCellProps={{
            padding: "checkbox"
        }}
    />;
};

export default CollapsibleEmptyCheckBoxCell;
